import { render } from "./App.vue?vue&type=template&id=6fb37673"
const script = {}
script.render = render

export default script